export const PER_PAGE_ALGOLIA_PROPERTY = 'PER_PAGE_ALGOLIA_PROPERTY'
export const PAGE_ALGOLIA_PROPERTY = 'PAGE_ALGOLIA_PROPERTY'
export const PAGES_ALGOLIA_PROPERTY = 'PAGES_ALGOLIA_PROPERTY'
export const HAS_NEXT_PAGE_ALGOLIA_PROPERTY = 'HAS_NEXT_PAGE_ALGOLIA_PROPERTY'
export const ARRAY_LIST_ALGOLIA_PROPERTY = 'ARRAY_LIST_ALGOLIA_PROPERTY'
export const IS_LOADING_ALGOLIA_PROPERTY = 'IS_LOADING_ALGOLIA_PROPERTY'
